module.exports = "https://img1.huilianyi.com/9/icon_alipay.9b35b1a820.appcore.png";